/**
 * Spacing between the tooltip and the target element (4px)
 */
export const TOOLTIP_SPACING_PX = 4;

/**
 * Delay before the tooltip appears (400ms)
 */
export const TOOLTIP_DELAY_MS = 400;

/**
 * Debounce delay for mouseover and mouseleave event listeners (250ms)
 */
export const DEBOUNCE_WAIT_MS = 250;

/**
 * ID of the tooltip container div element
 */
export const TOOLTIP_CONTAINER_ID = 'rd-tooltip-container';

/**
 * Tooltip Position (default: top)
 */
export enum TooltipPosition {
  top = 'top',
  bottom = 'bottom',
  left = 'left',
  right = 'right',
}

/**
 * Tooltip Alignment (default: center)
 */
export enum TooltipAlignment {
  center = 'center',
  left = 'left',
  right = 'right',
}
